import { TargetSegmentEnum } from "../../shared";
import { useCopilot_CategoriesQuery } from "../use-copilot-categories/graphql/copilot-categories.v5.generated";
import { useCopilotEndUserCategoriesQuery } from "../use-copilot-categories/graphql/copilot-end-user-categories.v5.generated";
import { adaptEndUserCategories, adaptToTopicHanaChipWidget } from "./utils";
export var useCopilotCategoriesBanner = function useCopilotCategoriesBanner(_ref) {
  var role = _ref.role,
    centralizedId = _ref.centralizedId;
  var _useCopilot_Categorie = useCopilot_CategoriesQuery({
      skip: role === TargetSegmentEnum.EndUser,
      context: {
        clientName: 'v5'
      }
    }),
    data = _useCopilot_Categorie.data,
    loading = _useCopilot_Categorie.loading,
    error = _useCopilot_Categorie.error,
    refetch = _useCopilot_Categorie.refetch;
  var skipEndUserCategories = role !== TargetSegmentEnum.EndUser || !centralizedId;
  var _useCopilotEndUserCat = useCopilotEndUserCategoriesQuery({
      variables: {
        centralizedOrganizationId: centralizedId
      },
      skip: skipEndUserCategories,
      context: {
        clientName: 'v5'
      }
    }),
    endUserCategoriesData = _useCopilotEndUserCat.data,
    endUserCategoriesLoading = _useCopilotEndUserCat.loading,
    endUserCategoriesError = _useCopilotEndUserCat.error,
    endUserCategoriesRefetch = _useCopilotEndUserCat.refetch;
  var categories = (data === null || data === void 0 ? void 0 : data.copilot_categories) || [];
  var endUserCategories = (endUserCategoriesData === null || endUserCategoriesData === void 0 ? void 0 : endUserCategoriesData.get_folder_category.edges.map(function (edge) {
    return edge.node;
  })
  //TODO: Remove this filter once the backend is updated and categories support end user redesign @pedro @nando
  .filter(function (node) {
    var _node$copilot_prompts, _node$copilot_prompts2;
    return ((_node$copilot_prompts = node.copilot_prompts) === null || _node$copilot_prompts === void 0 ? void 0 : _node$copilot_prompts.length) > 0 && ((_node$copilot_prompts2 = node.copilot_prompts) === null || _node$copilot_prompts2 === void 0 ? void 0 : _node$copilot_prompts2.some(function (prompt) {
      return prompt.template.prompt !== '';
    }));
  })
  // Remove duplicates based on category ID
  .filter(function (category, index, self) {
    return index === self.findIndex(function (c) {
      return c.id === category.id;
    });
  })) || [];
  var adaptedCategories;
  if (role === TargetSegmentEnum.EndUser) {
    adaptedCategories = adaptEndUserCategories(endUserCategories);
  } else {
    adaptedCategories = adaptToTopicHanaChipWidget(categories);
  }
  return {
    categories: categories,
    adaptedCategories: adaptedCategories,
    loading: role === TargetSegmentEnum.EndUser ? endUserCategoriesLoading : loading,
    error: role === TargetSegmentEnum.EndUser ? endUserCategoriesError : error,
    refetch: role === TargetSegmentEnum.EndUser ? endUserCategoriesRefetch : refetch
  };
};